module.exports = __webpack_public_path__ + "static/img/wangwenjing.a1036ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/wangwenjing.png
// module id = AR5L
// module chunks = 0